import { useRef } from "react";
import { motion, useMotionValue, useSpring, useTransform } from "framer-motion";

export default function MagneticButton({
  as: Comp = "button",
  children,
  className = "",
  strength = 24,
  ...props
}) {
  const ref = useRef(null);
  const x = useMotionValue(0);
  const y = useMotionValue(0);
  const sx = useSpring(x, { stiffness: 200, damping: 18, mass: 0.4 });
  const sy = useSpring(y, { stiffness: 200, damping: 18, mass: 0.4 });
  const tx = useTransform(sx, (v) => v);
  const ty = useTransform(sy, (v) => v);

  const onMove = (e) => {
    if (!ref.current) return;
    const r = ref.current.getBoundingClientRect();
    const rx = (e.clientX - (r.left + r.width / 2)) / (r.width / 2);
    const ry = (e.clientY - (r.top + r.height / 2)) / (r.height / 2);
    x.set(rx * strength);
    y.set(ry * strength);
  };
  const onLeave = () => {
    x.set(0);
    y.set(0);
  };

  return (
    <motion.div
      ref={ref}
      onMouseMove={onMove}
      onMouseLeave={onLeave}
      style={{ x: tx, y: ty }}
      className="inline-block"
    >
      <Comp className={className} {...props}>
        {children}
      </Comp>
    </motion.div>
  );
}
